import { I18n } from '@aws-amplify/core';

export const translateParts = (parts: string[], separator: string = ' '): string => {
    return parts.map(part => I18n.get(part)).join(separator);
};


export const translateWithBreaks = (parts: string[]): string => {
    return parts.map(part => I18n.get(part)).join('\n');
};


export const translateParagraphs = (parts: string[]): string => {
    return parts.map(part => I18n.get(part)).join('\n\n');
};


export const translateModalMessage = (parts: string[]): string => {
    parts.forEach(part => {
        if (part.length > 60) {
            console.warn(`⚠️ Chave de tradução muito longa: "${part}". Considere dividir em partes menores.`);
        }
    });

    return translateParts(parts);
};


export const debugTranslations = (parts: string[]): void => {
    console.group('🔍 Debug Traduções');
    parts.forEach(part => {
        console.log(`"${part}" → "${I18n.get(part)}"`);
    });
    console.groupEnd();
}; 